export const setProperty = (target: any, key: string, value: any, overwrite: boolean = true) => {
	if (!target || typeof target !== 'object') {
		throw new Error('Target must be an object or array.');
	}

	const keys = key.split('.');
	let current = target;

	for (let i = 0; i < keys.length; i++) {
		const part = keys[i];

		// Wenn wir am letzten Schlüssel angekommen sind, setzen wir den Wert
		if (i === keys.length - 1) {
			if (overwrite || !(part in current)) {
				current[part] = value;
			}
		} else {
			// Stelle sicher, dass der nächste Teil der Struktur existiert
			if (!(part in current) || typeof current[part] !== 'object') {
				current[part] = isNaN(Number(keys[i + 1])) ? {} : [];
			}
			current = current[part];
		}
	}
};
